

const ClockIcon = ({className}) => {
  return (
    <svg viewBox="0 0 24 24" fill="none" className={className}><g id="SVGRepo_bgCarrier" strokeWidth="0"></g><g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g><g id="SVGRepo_iconCarrier"> <path d="M12 7V12L13.5 9.5M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path> </g></svg>
  )
}

export default ClockIcon